import { defineMessages } from 'react-intl'

const baseId = 'dashboard.navigation'

export default defineMessages({
  telus_async_chat_text: {
    id: `${baseId}.telus_async_chat_text`,
    defaultMessage: 'Chat Consultations',
  },
})
